import { Link } from "react-router-dom";

export function AHeader({ title, subtitle, action }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-white">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function ACard({ title, children, action, className = "" }) {
  return (
    <div className={`rounded-xl border border-slate-800 bg-slate-900 ${className}`}>
      {title && (
        <div className="flex items-center justify-between border-b border-slate-800 px-5 py-3.5">
          <h3 className="font-display text-sm font-semibold text-white">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}

export function AStat({ label, value, sub, accent = "text-white", to, testid }) {
  const inner = (
    <>
      <div className="text-sm text-slate-400">{label}</div>
      <div className={`mt-2 font-display text-2xl font-bold ${accent}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </>
  );
  if (to) {
    return (
      <Link to={to} data-testid={testid} className="block rounded-xl border border-slate-800 bg-slate-900 p-5 transition-colors hover:border-accent/60 hover:bg-slate-800/60">
        {inner}
        <div className="mt-2 text-[11px] font-medium text-accent">Voir →</div>
      </Link>
    );
  }
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900 p-5">
      {inner}
    </div>
  );
}

export function ATable({ head, children }) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-slate-200">
        <thead><tr className="border-b border-slate-800 text-left text-xs text-slate-500">{head.map((h) => <th key={h} className="px-3 pb-2 font-medium">{h}</th>)}</tr></thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export const btnPrimary = "inline-flex items-center gap-2 rounded-full bg-accent px-5 py-2.5 text-sm font-medium text-white transition-opacity hover:opacity-90";
export const inputDark = "w-full rounded-lg border border-slate-700 bg-slate-800 px-3 py-2 text-sm text-white outline-none focus:ring-2 focus:ring-accent/50 placeholder:text-slate-500";
